/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './AutoActionMailView.scss'
import React from 'react'
import _ from 'lodash'
import r from '../../../util/Renderer'
import { DeleteButton, Dropdown, ListItem, TextInput } from '../../atoms'
import { Edit, ListGroup } from '../../molecules'
import Cell from '../../templates/Cell'
import LocalArea from '../../templates/LocalArea'
import AutoActionConfigView from '../../organisms/auto_action/AutoActionConfigView'
import AutoMailActions from '../../../action/auto_action/AutoMailActions'
import { NavigationDrawer, NormalButton, TextButton } from 'ui-library/dist/external/components'

function AutoActionMailView(props) {
  const id = props.match.params.id || null
  const showEdit = _.propertyOf(props)('showEdit') || false
  const toolbar = { label: '自動送信メール', items: props.accountMenu }
  const meta = { label: '自動登録タスク' }

  return (
    <div id="AutoActionMail">
      <NavigationDrawer toolbar={toolbar} navigations={props.navigations} meta={meta} />

      <LocalArea>
        {/*<div className="LocalArea--left">*/}
        {/*<SearchField placeholder="名前" name="search_keywords"  />*/}
        {/*</div>*/}
        <div className="LocalArea--right">
          <NormalButton onClick={() => AutoMailActions.onCreate()}>新規作成</NormalButton>
        </div>
      </LocalArea>

      <div className="AutoActionMail__List">
        <ListGroup border="underline" className="ItemGroup">
          {props.mails.map(mail => new AutoMailRowItem(mail))}
        </ListGroup>

        {r.renderIf(showEdit)(
          // 設定されている値を View に渡す
          <AutoMailEditView id={id} mail={props.mail} room_options={props.room_options} site_referrer_options={props.site_referrer_options} smtp_setting_options={props.smtp_setting_options} />
        )}
      </div>
    </div>
  )
}

function AutoMailRowItem(auto_action_mail) {
  return (
    <ListItem key={auto_action_mail.id} className="Item">
      <div className="col-12">
        <div className="row">
          <div className="col-8 col-lg-8 align-self-center">
            <Cell className="Item__Name">
              <span>{auto_action_mail.name}</span>
            </Cell>
          </div>
          <div className="ml-auto col-auto align-self-center">
            <Cell className="Item__Action">
              <TextButton onClick={() => AutoMailActions.onCreateWithCopy(auto_action_mail.id)}>コピーを新規作成</TextButton>
            </Cell>
          </div>
          <div className="ml-auto col-auto align-self-center">
            <Cell className="Item__Action">
              <NormalButton onClick={() => AutoMailActions.onUpdate(auto_action_mail)}>編集</NormalButton>
            </Cell>
          </div>
        </div>
      </div>
    </ListItem>
  )
}

function AutoMailEditView(props) {
  const mail = props.mail

  return (
    <Edit
      title={props.id ? `自動メールID：${props.id}` : '自動送信メールの作成'}
      buttonLabel={props.id ? '更新' : '作成'}
      onSubmit={props.id ? () => AutoMailActions.onRequestUpdate(mail) : () => AutoMailActions.onRequestCreate(mail)}
      onCancel={AutoMailActions.onCancel}
    >
      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={mail.name} type="text" name="name" label={'自動メール名'} placeholder="自動メールを識別するための名前" option="required" onChange={AutoMailActions.onEdit} />
          </div>
        </div>
      </div>

      <AutoActionConfigView
        config={mail.getConfig()}
        rooms={props.room_options}
        site_referrers={props.site_referrer_options}
        room_ids={mail.room_ids}
        site_referrer_ids={mail.site_referrer_ids}
        onEdit={AutoMailActions.onEdit}
      />

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <div className="textInput__label textInput__label- textInput__label-required">
              メール送信元
              <div className="textInput__optionIcon" />
            </div>
            <Dropdown
              className="Dropdown--wide"
              name="smtp_setting_id"
              options={props.smtp_setting_options}
              value={mail.smtp_setting_id}
              onChange={AutoMailActions.onEdit}
              placeholder="メール送信元"
            />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={mail.mail_reply_to} type="text" name="mail_reply_to" label={'メール返信先'} placeholder="noreply@example.com" option="required" onChange={AutoMailActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput
              value={mail.mail_to}
              type="text"
              name="mail_to"
              label={'メール送信先'}
              placeholder="to@example.com"
              caution="カンマで「,」区切って複数指定できます"
              onChange={AutoMailActions.onEdit}
            />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={mail.mail_cc} type="text" name="mail_cc" label={'メール送信先(CC)'} caution="カンマで「,」区切って複数指定できます" onChange={AutoMailActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={mail.mail_bcc} type="text" name="mail_bcc" label={'メール送信先(BCC)'} caution="カンマで「,」区切って複数指定できます" onChange={AutoMailActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__row">
        <div className="EditArea__row--full">
          <div className="EditArea__column">
            <TextInput value={mail.title} type="text" name="title" label={'件名'} placeholder="メールの件名" option="required" onChange={AutoMailActions.onEdit} />
          </div>
        </div>
      </div>

      <div className="EditArea__column">
        <div className="textInput__label textInput__label- textInput__label-required">
          本文
          <div className="textInput__optionIcon" />
        </div>
        <textarea className="EditArea__row--full" name="body" value={mail.body || ''} rows="12" onChange={AutoMailActions.onEdit} />
      </div>

      {r.renderIf(props.id)(
        <div className="EditArea__row">
          <div className="EditArea__row--full">
            <div className="EditArea__column">
              <DeleteButton onClick={() => AutoMailActions.onRequestDelete(props.id)}>削除</DeleteButton>
            </div>
          </div>
        </div>
      )}
    </Edit>
  )
}

export default AutoActionMailView
